/**
 * Row-model subjects (jobs, contacts, offers) keep static and custom field
 * placement on the same `ats_form_fields` rows, so `form_fields` returns BOTH
 * kinds in one flat list — that is what lets the two be reordered against each
 * other in settings.
 *
 * Consumers that build custom-field controls want only the custom rows: the
 * static ones are already rendered by their own hand-written config, and
 * passing them through generateCustomFormConfig renders every default twice.
 * Section-level order still comes from `ats_form_template.static_fields`.
 */
export interface FlatFormField {
  field_kind?: string;
  [key: string]: unknown;
}

export const customFormFields = <T extends FlatFormField>(
  formFields: T[] | undefined | null
): T[] => (formFields || []).filter((field) => field?.field_kind !== 'static');
